import Lock from "../assets/icon_lock.svg";
import moment from "moment";
import {getDailyTableName, getNameByCode} from "../helpers/functions";
import {TableTop} from "./TableTop";
import {TablePrizes} from "./TablePrizes";
import {useState} from "react";


export const FutureRace = (props) => {
    const {type} = props
    const {title} = getNameByCode(props.races[0].code)
    const phoneView = window.innerWidth < 768
    const [selectedTab, setSelectedTab] = useState(1)
    const differentMonth = moment(props.races[0].start).format('MM') !== moment(props.races[0].end).format('MM')
    return (
        <>
            <div className="section-future-subhead">
                <div>
                    <span className="section-future-subhead-title">{title}</span>
                    <img src={Lock} alt="icon_lock" />
                </div>
                <p className="section-future-subhead-period">{moment(props.races[0].start).format(differentMonth ? 'D MMMM' : 'D') + ' - ' + moment(props.races[0].end).locale('ro').format('D MMMM')}</p>
            </div>
            <div className={"section-wrapper " + (type === 'double' ? '' : ' single-table-race single')}>
                {type === 'double' && <div className={'tabs ' + (phoneView ? 'long-tab ' : '') + (selectedTab === 2 ? 'toRight' : '')}>
                    <p onClick={() => setSelectedTab(1)}
                       className={'tab ' + (selectedTab === 1 ? 'active-tab' : '')}>Clasament</p>
                    <p onClick={() => setSelectedTab(2)} className={'tab ' + (selectedTab === 2 ? 'active-tab' : '')}>{getDailyTableName(props.races[1].code)}</p>
                </div>}
                <TableTop raceRef={props.myRef} inactive={props.inactive} visible={selectedTab === 1} isFutureRace data={props.races[0]}/>
                {type === 'double' ? <TablePrizes raceRef={props.myRef} inactive={props.inactive} visible={selectedTab === 2} isFutureRace data={props.races[1]}/> : <></>}
            </div>
        </>
    )
}